import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { FulfillmentMethodExtend, StoreFulfillmentMethod } from "@store/Services/SessionService";
import { ShipViaModel } from "@store/Types/ShipVia";

export default (shipVias: string) => {
    const availableShipVias = shipVias ? JSON.parse(shipVias) : undefined;

    const isFulfillmentAvailable = (fulfillmentMethod: FulfillmentMethodExtend | FulfillmentMethod) => {
        return availableShipVias ?
            availableShipVias.some((availableShipVia: ShipViaModel) => {
                return availableShipVia.FulfillmentMethod === fulfillmentMethod
            })
        : undefined;
    };

    const isPickupAvailable = isFulfillmentAvailable(StoreFulfillmentMethod.PickUp);
    const isShipAvailable = isFulfillmentAvailable(StoreFulfillmentMethod.Ship);
    const isDeliveryAvailable = isFulfillmentAvailable(StoreFulfillmentMethod.Delivery);

    return {isPickupAvailable, isShipAvailable, isDeliveryAvailable};
};